<div
  ngpTabset
  [ngpTabsetValue]="activeId"
  (ngpTabsetValueChange)="onTabChange($event)"
  class="language-pills"
>
  <div ngpTabList class="language-pills__list">
    @for (language of languages; track language.id) {
      <button
        type="button"
        ngpTabButton
        [ngpTabButtonValue]="language.id.toString()"
        class="language-pills__tab"
      >
        {{ language.name }}
      </button>
    }
  </div>
</div>
